import React, {useCallback, useEffect, useMemo, useState} from "react";
import axios from "axios";
import "./AddDocumentToCase.css";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CaseFilesInternal from "../../../enums/CaseFilesInternal";
import {IoIosCloseCircle} from "react-icons/io";
import CaseFilesStatus from "../../../enums/CaseFilesStatus";
import CaseFileDeclined from "../../../enums/CaseFileDeclined";
import AdditionalDocumentEnum from "../../../enums/AdditionalDocumentEnum";
import {Button, FormControl, InputLabel, MenuItem, Select, Tooltip} from "@mui/material";
import {useLocation} from "react-router-dom";
import JoditEditor from "jodit-react";
import {jwtDecode} from "jwt-decode";
import CaseNotificationEnum from "../../../enums/CaseNotiFicationEnum";
import htmlEnums from "../../../enums/htmlEnums";
import TemplateEnum from "../../../enums/templateEnum";
import {debounce} from "lodash";
import {formatHtmlForEditor} from "../../../components/globalFunctions/globalFunctions";
import {AiOutlineCheckCircle} from "react-icons/ai";


const AdditionalFileRequest = ({
                                   onFileAdded,
                                   Disabled,
                                   docType,
                                   buttonTitle,
                                   userId,
                                   barcode,
                                   users,
                                   userAddress
                               }) => {
    const location = useLocation();
    const caseId = new URLSearchParams(location.search).get('id');
    const [title, setTitle] = useState("");
    const [documentType, setDocumentType] = useState("");
    const [extraDescription, setExtraDescription] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editorContent, setEditorContent] = useState('');
    const [closing, setClosing] = useState(false);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [previewContent, setPreviewContent] = useState('');
    const isSubmitDisabled = !title || isEditorContentEmpty(editorContent) || !documentType;
    const [fontFamily, setFontFamily] = useState('Sylfaen');
    const [closeModalOn, setCloseModalOn] = useState(false);
    const [roleId, setRoleId] = useState('');
    const [headerContent, setHeaderContent] = useState('');
    const [htmlLoaded, setHtmlLoaded] = useState(false);
    const [debouncedContent, setDebouncedContent] = useState(editorContent);


    const debouncedUpdatePreview = useCallback(debounce(newContent => {
        setDebouncedContent(newContent);
    }, 50), []);


    useEffect(() => {
        debouncedUpdatePreview(editorContent);
    }, [editorContent, debouncedUpdatePreview]);


    const PdfPreviewContent = useMemo(() => {
        return (
            <div className="pdf-preview-container" style={{fontFamily}}>
                <Button
                    variant="contained"
                    color="primary"
                    style={{marginBottom: 28}}
                    startIcon={<AiOutlineCheckCircle />}
                >
                    ცვლილების ნახვა
                </Button>
                <div id="pdf-page" className="pdf-page" style={{fontFamily}}>
                    <div dangerouslySetInnerHTML={{__html: headerContent}}/>
                    <div dangerouslySetInnerHTML={{__html: previewContent}}/>
                    <div style={{marginTop: 10}}
                         dangerouslySetInnerHTML={{__html: debouncedContent}}/>
                </div>
            </div>
        );
    }, [fontFamily, previewContent, debouncedContent, headerContent]);


    useEffect(() => {
        if (showPopup) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showPopup]);

    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
            } catch (error) {
                setRoleId("");
            }
        }
    }, []);

    const sendNotification = async (fileId) => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: fileId,
            action: CaseNotificationEnum.createdFile.id,
            caseStatus: 8,
            viewed: true,

        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };

    const georgianTranslations = {
        "Type something": " ",
        "Bold": "ტექსტის გამუქება",
        "Italic": "დახრილი ტექსტის შექმნა",
        "Underline": "ტექსტის ხაზგასმა",
        "Insert Image": "სურათის ჩასმა",
        "Clear Formatting": "ფორმატირების წაშლა",
        "Insert Format Block": "ფორმატირების ბლოკის ჩასმა",
        "Strike through": "გადახაზული",
        "Insert Unordered List": "ბურთულებიანი სიის შექმნა",
        "Insert Ordered List": "დანომრილი სიის შექმნა",
        "Font family": "შრიფტის არჩევა",
        "Font size": "შრიფტის ზომა",
        "Line height": "ხაზის დაშორება",
        "Insert Horizontal Line": "ხაზის დაშორება",
        "Increase Indent": "დაშორების გაზრდა",
        "Decrease Indent": "დაშორების შემცირება",
        "Undo": "უკუსვლა",
        "Redo": "საწყისი",
        "Align": "სწორება",
        "Insert Special Character": "სპეც. სიმბოლო",
        "Fill color or set the text color": "ფერის შეცვლა",
        "Background": "ფონი",
        "Text": "ტექსტი",
        "Insert format block": "ფორმატირება",
        "Print": "დაბეჭვდა",
        "Show all": "მეტის ნახვა",
        "Insert link": "ბმლის ჩასმა",
        "URL": "ბმული",
        "Open in new tab": "ახალ გვერდზე გახსნა",
        "Insert": "ჩასმა"
    };

    const mapFontFamilyToStyles = (fontName) => {
        const fontStyles = {
            'Arial': {
                fontFamily: 'arial_geo',
                bold: 'arial_geo-bold',
                italics: 'arial_geo-italic',
                bolditalics: 'arial_geo-bold-italic'
            },
            'Sylfaen': {
                fontFamily: 'sylfaen',
                bold: 'arial_geo-bold',
                italics: 'arial_geo-italic',
                bolditalics: 'arial_geo-bold-italic'
            }
        };
        return fontStyles[fontName] || fontStyles['Arial'];
    };


    const editorConfig = useMemo(() => ({
        readonly: false,
        toolbarButtonSize: "middle",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        language: 'ka',
        i18n: {
            ka: georgianTranslations,
        },
        style: {
            fontFamily: mapFontFamilyToStyles(fontFamily).fontFamily,
        },
        height: 800,
        disablePlugins: [
            'spellcheck',
            'speech-recognize',
            'open-in-fullsize',
            'add-new-line',
            'Insert-file',
            'ai-assistant',
            'file',
            'image',
            'video',
            'fullsize',
            'about',
            'preview',
            'symbols',
            'symbol',
        ],
        controls: {
            font: {
                list: {
                    'Arial': 'Arial',
                    'Sylfaen': 'Sylfaen'
                }
            }
        },
        buttons: ["bold", "italic", "underline", "|", "subscript", "superscript"]

    }), []);


    useEffect(() => {
        const styleSheet = document.createElement('style');
        styleSheet.type = 'text/css';
        styleSheet.innerText = `
        .jodit-container * {
            font-family: ${mapFontFamilyToStyles(fontFamily).fontFamily} !important;
        }
    `;
        document.head.appendChild(styleSheet);

        return () => {
            document.head.removeChild(styleSheet);
        };
    }, [fontFamily]);

    const preprocessHtmlForPdf = (html) => {
        const container = document.createElement('div');
        container.innerHTML = html;

        const elementsWithStyle = container.querySelectorAll('[style]');
        elementsWithStyle.forEach(element => {
            const style = element.style;

            if (style.fontSize && isNaN(parseFloat(style.fontSize))) {
                style.fontSize = '16px';
            }

            if (style.textDecoration === 'none') {
                style.textDecoration = '';
            }
        });
        const tables = container.querySelectorAll('table');
        tables.forEach(table => {
            table.style.width = '100%'; // Ensures tables stretch to the full page width
            const rows = table.querySelectorAll('tr');
            rows.forEach(tr => {
                tr.querySelectorAll('td, th').forEach(td => {
                    td.style.padding = '8px'; // Ensure consistent padding
                });
            });
        });

        return container.innerHTML;
    };


    useEffect(() => {
        const fetchAndSetBarcode = async () => {
            if (docType && htmlLoaded) {
                setDocumentType(docType.documentTypeStatus);
                setTitle(docType.name);

                let blankHtmlContent = docType.blank;
                const barcodeImageBase64 = barcode;

                if (barcodeImageBase64 && docType.templateType !== TemplateEnum.insideLetter) {
                    blankHtmlContent = insertBarcodeIntoContent(barcodeImageBase64, blankHtmlContent);
                } else if (barcodeImageBase64 && docType.templateType === TemplateEnum.insideLetter) {
                    blankHtmlContent = insertBarcodeIntoContentForInsideLetter(barcodeImageBase64, blankHtmlContent)
                }
                setPreviewContent(blankHtmlContent);
                if (docType.templateType !== null) {
                    if (docType.templateType === TemplateEnum.order) {
                        setHeaderContent(htmlEnums.order)
                    } else if (docType.templateType === TemplateEnum.letter) {
                        setHeaderContent(htmlEnums.letter)
                    }

                }

                setPreviewContent(blankHtmlContent);
            }
        };

        void fetchAndSetBarcode();
    }, [docType, htmlLoaded]);

    useEffect(() => {
        if (htmlEnums && Object.keys(htmlEnums).length > 0) {
            setHtmlLoaded(true);
        }
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && showPopup) {
                setCloseModalOn(true)
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [closing, showPopup]);



    const handleFontChange = (e) => {
        setFontFamily(e.target.value);
    };


    const preprocessEditorContent = (htmlContent) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');

        doc.querySelectorAll('p, br').forEach(el => {
            if (el.style.marginTop === '70px') {
                el.style.marginTop = '0px';
            }
        });

        return doc.body.innerHTML;
    };

    useEffect(() => {
        const processedContent = preprocessEditorContent(editorContent);
        setEditorContent(processedContent);
    }, [editorContent]);


    const resetForm = () => {
        setTitle("");
        setEditorContent("");
        setExtraDescription("");
        setDocumentType("");
    };

    function isEditorContentEmpty(content) {
        return !content.replace(/<[^>]*>/g, '').trim();
    }


    const insertBarcodeIntoContent = (base64ImageData, htmlContent) => {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = htmlContent

        const table = document.createElement('table')
        table.style.width = '100%'
        table.style.borderCollapse = 'collapse'
        table.style.border = 'none'

        const headerRow = document.createElement('tr')

        const dateTableCell = document.createElement('td')
        dateTableCell.style.verticalAlign = 'middle'
        dateTableCell.style.border = 'none'
        dateTableCell.style.padding = '0'
        dateTableCell.style.color = 'black'
        dateTableCell.style.fontFamily = 'Sylfaen'
        dateTableCell.style.fontSize = '20px'
        dateTableCell.textContent = '{ხელმოწერის თარიღი}'

        headerRow.appendChild(dateTableCell)

        const barcodeTableCell = document.createElement('td')
        barcodeTableCell.style.verticalAlign = 'middle'
        barcodeTableCell.style.textAlign = 'right'
        barcodeTableCell.style.border = 'none'
        barcodeTableCell.style.padding = '0'

        const barcodeContainer = document.createElement('div')

        const barcodeImage = document.createElement('img')
        barcodeImage.src = base64ImageData
        barcodeImage.style.width = '200px'
        barcodeImage.style.height = '50px'

        barcodeContainer.appendChild(barcodeImage)

        const generateRandomNumberString = length => {
            let generatedValue = ''
            for (let index = 0; index < length; index++) {
                generatedValue += Math.floor(Math.random() * 10)
            }
            return generatedValue
        }

        const barcodeText = 'KA' + generateRandomNumberString(15)

        const barcodeTextDiv = document.createElement('div')
        barcodeTextDiv.style.fontSize = '14px'
        barcodeTextDiv.style.color = 'black'
        barcodeTextDiv.style.fontFamily = 'Sylfaen'
        barcodeTextDiv.textContent = barcodeText

        barcodeContainer.appendChild(barcodeTextDiv)
        barcodeTableCell.appendChild(barcodeContainer)

        headerRow.appendChild(barcodeTableCell)
        table.appendChild(headerRow)

        const documentRow = document.createElement('tr')

        const documentNumberCell = document.createElement('td')
        documentNumberCell.style.verticalAlign = 'middle'
        documentNumberCell.style.border = 'none'
        documentNumberCell.style.padding = '0'
        documentNumberCell.style.paddingTop = '50px'

        const documentNumberDiv = document.createElement('div')
        documentNumberDiv.textContent = '{დოკუმენტის ნომერი}'
        documentNumberDiv.style.fontSize = '18px'
        documentNumberDiv.style.color = 'black'
        documentNumberDiv.style.fontFamily = 'Sylfaen'

        documentNumberCell.appendChild(documentNumberDiv)

        const emptyCell = document.createElement('td')
        emptyCell.style.border = 'none'
        emptyCell.style.padding = '0'

        documentRow.appendChild(documentNumberCell)
        documentRow.appendChild(emptyCell)

        table.appendChild(documentRow)

        tempDiv.appendChild(table)
        return tempDiv.innerHTML
    }

    const insertBarcodeIntoContentForInsideLetter = (base64ImageData) => {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = '<div></div>'

        const contentContainer = document.createElement('div')
        contentContainer.style.position = 'relative'
        contentContainer.style.width = '100%'
        contentContainer.style.textAlign = 'right'

        tempDiv.appendChild(contentContainer)

        const barcodeImage = document.createElement('img')
        barcodeImage.src = base64ImageData
        barcodeImage.style.width = '150px'
        barcodeImage.style.height = '30px'

        contentContainer.appendChild(barcodeImage)

        const insideLetterDiv = document.createElement('div')
        insideLetterDiv.innerHTML = htmlEnums.insideLetter
        insideLetterDiv.style.marginTop = '10px'
        insideLetterDiv.style.textAlign = 'center'

        contentContainer.appendChild(insideLetterDiv)

        const dateSpan = document.createElement('span')
        dateSpan.textContent = "{ხელმოწერის თარიღი}"
        dateSpan.style.fontSize = '18px'
        dateSpan.style.color = 'black'
        dateSpan.style.marginRight = '15px'
        dateSpan.style.fontFamily = 'Sylfaen'
        dateSpan.style.letterSpacing = '-0.5px'

        contentContainer.appendChild(dateSpan)

        return tempDiv.innerHTML
    }

    const handleClosePopup = () => {
        setCloseModalOn(false)
        setClosing(true);
        setTimeout(() => {
            setShowPopup(false);
            setClosing(false);
        }, 500);
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        setIsConfirmModalOpen(true);
    };


    const handleConfirmSubmit = async () => {
        setIsConfirmModalOpen(false);
        setLoading(true);

        const forceFontFamily = (htmlContent) => {
            const container = document.createElement('div');
            container.innerHTML = htmlContent;
            return container.innerHTML;
        };

        const updatedPreviewContent = forceFontFamily(previewContent.replace(/background-color:\s*transparent;\s*/g, ''));
        const updatedEditorContent = forceFontFamily(editorContent.replace(/background-color:\s*transparent;\s*/g, ''));

        setPreviewContent(updatedPreviewContent);
        setEditorContent(updatedEditorContent);


        const processedContent = preprocessHtmlForPdf(`<div style="font-family: ${fontFamily}">${headerContent}${updatedPreviewContent}${updatedEditorContent}</div>`);
        const processedHtml = formatHtmlForEditor(processedContent);


            const requestBody = {
                caseID: parseInt(caseId),
                name: title,
                ext: 'pdf',
                mainInfo: processedHtml,
                additionalInfo: extraDescription,
                sharedTemp: true,
                shared: false,
                blank: true,
                documentType: documentType,
                internal: CaseFilesInternal.No,
                status: CaseFilesStatus.ReadyForVisage,
                decline: CaseFileDeclined.No,
                approvalDocument: false,
                isRequestedAdditionalDocument: AdditionalDocumentEnum.RequestAdding,
                declinedInternalStatus: 0,
                activeUserId: userId,
                html: processedHtml,
                isHTML: true,
                skipVisage: docType.skipVisage
            };

            try {
                const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, requestBody);
                await sendNotification(response.data.resultId)
                onFileAdded();
                resetForm();
            } catch (error) {
                setLoading(false);
                setShowPopup(false);
            } finally {
                setLoading(false);
                setShowPopup(false);
            }
    };


    return (
        <div>
            <button
                className="document-button"
                onClick={() => {
                    setShowPopup(true);
                }}
                disabled={Disabled}
                title={Disabled ? "დამატებითი ფაილიების მოთხოვნის აქტი უკვე შექმნილია" : ""}
            >
                {buttonTitle}
            </button>
            {showPopup && (
                <div className="overlay" onClick={() => setCloseModalOn(true)}></div>
            )}
            {showPopup && (
                <div className={`custom-scrollbar popup-editor ${closing ? 'popup-closing' : ''}`}>
                    {loading ? (
                        <div className="loader"></div>
                    ) : (
                        <div className="editor-and-preview-container">
                            <div>
                                <form onSubmit={handleSubmit}>
                                    <input
                                        type="text"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                        placeholder="სათაური"
                                        className={"add-doc-input"}
                                    />
                                    <div className="q-editor-container">

                                        <FormControl fullWidth style={{marginBottom: 8}}>
                                            <InputLabel id="font-family-label">შრიფტი</InputLabel>
                                            <Select
                                                labelId="font-family-label"
                                                value={fontFamily}
                                                label="შრიფტი"
                                                onChange={handleFontChange}
                                                sx={{backgroundColor: 'white', borderRadius: 1}}
                                            >
                                                <MenuItem value="DejaVu">DejaVu Sans</MenuItem>
                                                <MenuItem value="Sylfaen">Sylfaen</MenuItem>

                                            </Select>
                                        </FormControl>
                                        <JoditEditor
                                            key={fontFamily}
                                            value={editorContent}
                                            config={editorConfig}
                                            tabIndex={1}
                                            onBlur={editorContent => setEditorContent(editorContent)}
                                        />

                                    </div>
                                    <textarea
                                        value={extraDescription}
                                        onChange={(e) => setExtraDescription(e.target.value)}
                                        placeholder="დამატებითი აღწერა"
                                        style={{
                                            width: "99.39%",
                                            height: "200px",
                                            resize: "vertical",
                                            margin: "10px 0",
                                        }}
                                    />

                                    <Tooltip title={isSubmitDisabled ? "შეავსეთ ყველა ველი" : ""}>

                                        <button
                                            type="submit"
                                            style={{
                                                backgroundColor: isSubmitDisabled ? '#ccc' : '#2E76E4',
                                                color: isSubmitDisabled ? '#666' : 'white',
                                                cursor: isSubmitDisabled ? 'not-allowed' : 'pointer'
                                            }}
                                            className="doc-submit-button"
                                            disabled={isSubmitDisabled  || loading}
                                        >
                                            დოკუმენტის შექმნა
                                        </button>
                                    </Tooltip>
                                </form>
                            </div>
                            {PdfPreviewContent}
                        </div>
                    )}
                    <IoIosCloseCircle className="upload-single-close-icon-text-editor"
                                      onClick={() => setCloseModalOn(true)}
                    />
                    <ConfirmationModal
                        isOpen={isConfirmModalOpen}
                        onRequestClose={() => setIsConfirmModalOpen(false)}
                        onConfirm={handleConfirmSubmit}
                    />

                    <ConfirmationModal
                        isOpen={closeModalOn}
                        onRequestClose={() => setCloseModalOn(false)}
                        onConfirm={handleClosePopup}
                    />
                </div>
            )}
            {loading && <div className="loader"></div>}
        </div>
    );
};

export default AdditionalFileRequest;
